



































































































import { Component } from 'vue-property-decorator';

import { getBillingIsHidden } from '@/utils/billing';
import isMobile from '@/utils/mobile-check';

import { Surface, Picture, Typography } from '@/components/atoms';
import { FilledButton } from '@/components/molecules';
import BillingModel from '@/views/Models/BillingModel.vue';
import CoinNetworkFeatureTag from '@/componentsV2/atoms/CoinNetworkFeatureTag/CoinNetworkFeatureTag.vue';

@Component({
  components: {
    Surface,
    Picture,
    Typography,
    FilledButton,
    CoinNetworkFeatureTag
  }
})
export default class LocationEmptyState extends BillingModel {
  get isMobileDevice() {
    return isMobile();
  }

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get name() {
    return this.business.name;
  }

  get ctaLabel() {
    if (getBillingIsHidden()) return 'Add a physical location';

    return 'Add a physical location & Upgrade';
  }

  // Not BillingModel.showCoinNetworkTag: that getter also hides the tag for
  // UNAVAILABLE merchants — exactly this empty state's audience — while this
  // tag always rendered here. Flag off it must keep doing that (TWISM-19139).
  get showBillingTag() {
    return !getBillingIsHidden();
  }

  // With billing hidden, adding a location no longer requires a subscription, so
  // the CTA skips the billing acceptance modal and opens the plain add-location
  // form owned by the parent (TWISM-19139).
  onClickCTA() {
    if (getBillingIsHidden()) {
      this.$emit('add-location');
      return;
    }

    this.onClickUpgrade({
      props: {
        welcomeCtaText: 'Explore Locations',
        origin: 'Empty State Locations',
        action: 'Acceptance'
      }
    });
  }
}
